<div
  ngbDropdown
  #locationDropdown="ngbDropdown"
  class="location-dropdown"
  [autoClose]="isMobile ? false : 'outside'"
  (openChange)="openChange.emit($event)"
  [class.is-mobile]="isMobile"
>
  <span class="dropdown-anchor" ngbDropdownAnchor></span>

  <div class="field-container" (click)="locationDropdown.open()">
    <span *ngIf="!isMobile" class="field-label">{{ 'location' | t }}</span>

    <div class="field-input">
      <ng-container *ngIf="selected.length < 2">
        {{ locationValue }}
      </ng-container>

      <app-badge-row
        *ngIf="selected.length > 1"
        [max]="0"
        units="Countries"
        [onlyCounter]="true"
        [items]="selectedLocationBadges"
        class="badges"
      ></app-badge-row>
    </div>
  </div>

  <div class="location-dropdown__menu" ngbDropdownMenu>
    <span class="dropdown-title">Locations</span>

    <div class="location-list">
      <span
        *ngFor="let country of selected"
        class="closable location-item"
        (click)="onLocationRemove(country.country_id)"
      >
        {{ country.country_name }}
      </span>

      <span
        *ngFor="let country of getUnselectedCountries(countries$ | ngrxPush)"
        class="location-item"
        (click)="onLocationAdd(country)"
      >
        {{ country.country_name }}
      </span>
    </div>
  </div>
</div>
